module.exports = __webpack_public_path__ + "img/inkie-big.5ffd5f10.gif";